import { render, staticRenderFns } from "./input.vue?vue&type=template&id=bb066ec2&scoped=true&lang=pug&"
import script from "./input.vue?vue&type=script&lang=js&"
export * from "./input.vue?vue&type=script&lang=js&"
import style0 from "./input.vue?vue&type=style&index=0&id=bb066ec2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb066ec2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\git\\front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb066ec2')) {
      api.createRecord('bb066ec2', component.options)
    } else {
      api.reload('bb066ec2', component.options)
    }
    module.hot.accept("./input.vue?vue&type=template&id=bb066ec2&scoped=true&lang=pug&", function () {
      api.rerender('bb066ec2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/edit/input.vue"
export default component.exports